import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/course/base/page',
    add:'/api-ir/bachelor/course/base/add',
    update:'/api-ir/bachelor/course/base/edit',
    info:'/api-ir/bachelor/course/base/info/',
    del:'/api-ir/bachelor/course/base/delete/',
    relate:'/api-ir/bachelor/course/base/relate',
    books:'/api-ir/bachelor/course/base/relate/books/',
    export:'/api-ir/bachelor/course/base/export'
}
// 查询课程列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询课程信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除课程
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
// 关联教材
export function relate (data) {
    return baseAPI.axiosData(api.relate,'post',data)
}
// 删除课程
export function books (id) {
    return baseAPI.axiosData(api.books+id,'get')
}

export function exportTable (data) {
    return baseAPI.axiosData(api.export,'get',data)
}